/**
* index.js
* Copyright: Microsoft 2016
*
* Points at typescript source for using with webpack/TSC.
*/

var resub = require('./dist/ReSub');
module.exports = resub;



//////////////////
// WEBPACK FOOTER
// ./node_modules/resub/index.js
// module id = 349
// module chunks = 0